
// Languages component
import { defineComponent, PropType } from 'vue'
import CvSection from './CvSection.vue'
import { IEnRu } from '@/store/cvInterfaces'

export default defineComponent({
  components: {
    CvSection,
  },
  props: {
    data: {
      type: Array as PropType<IEnRu[]>,
      required: true,
    },
  },
})
